import { renderLineBreaks } from "../../../utils";
import { Book } from "../../../lib/icons";
import { NextImage } from "..";
import { CardHeaderWrapper, IconContainer } from "./styles";

export const CardHeader = ({ icon, title, hideIcon }) => {
  return (
    <CardHeaderWrapper>
      <IconContainer hideIcon={hideIcon}>
        {icon ? <NextImage media={icon} alt={title} /> : Book}
      </IconContainer>
      <p>{renderLineBreaks(title)}</p>
    </CardHeaderWrapper>
  );
};

export default CardHeader;
